"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrimaryTip = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _getClassesPropType = require("../../../helpers/getClassesPropType");

var _useStyles = require("../../../helpers/useStyles");

var _classnames = _interopRequireDefault(require("classnames"));

var _iconButton = require("../../icon-button");

var _SvgBtClose = require("../../svg/icons/SvgBtClose");

var _SvgInLamp = require("../../svg/interface/SvgInLamp");

var _SvgInWarning = require("../../svg/interface/SvgInWarning");

var _loadStyles = _interopRequireDefault(require("load-styles"));

(0, _loadStyles.default)(".c2b197aef{border-radius:.3125rem;padding:1.25rem;color:var(--color-flomni-gray-90);display:grid;grid-template-columns:fit-content(100%) 1fr;grid-gap:.625rem;grid-gap:.625rem;gap:.625rem;grid-gap:.625rem}.cf20d01bf{display:flex;padding:.125rem;color:var(--color-flomni-yellow-50)}.cab1c135a{grid-template-columns:fit-content(100%) 1fr fit-content(100%)}.ca091d31e{display:block;word-break:break-word}.c859c0c0e{background:#fffbea}.c19b4b7cc{background:#f9f6fc}.c19b4b7cc .cf20d01bf{color:var(--color-flomni-rose-70)}.c3caab267{background:#eef2fb}.c3caab267 .cf20d01bf{color:var(--color-flomni-blue-70)}.c89e99af2{font-size:.875rem;font-weight:400;line-height:1.5rem}.ca7bb83ae{font-size:1rem;font-weight:400;line-height:1.5rem}");
var styles = {
  root: 'c2b197aef',
  icon: 'cf20d01bf',
  '--closable': 'cab1c135a',
  content: 'ca091d31e',
  '--view-usual': 'c859c0c0e',
  '--view-warning': 'c19b4b7cc',
  '--view-info': 'c3caab267',
  '--size-small': 'c89e99af2',
  '--size-usual': 'ca7bb83ae'
};

var PrimaryTip = function PrimaryTip(props) {
  var children = props.children,
      classes = props.classes,
      closable = props.closable,
      onClose = props.onClose,
      view = props.view,
      size = props.size;
  var cn = (0, _useStyles.useStyles)(styles, classes);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(cn.root, cn.view[view], cn.size[size], (0, _defineProperty2.default)({}, cn.closable, closable))
  }, view !== 'usual' ? null : /*#__PURE__*/_react.default.createElement("div", {
    className: cn.icon
  }, /*#__PURE__*/_react.default.createElement(_SvgInLamp.SvgInLamp, null)), view !== 'warning' && view !== 'info' ? null : /*#__PURE__*/_react.default.createElement("div", {
    className: cn.icon
  }, /*#__PURE__*/_react.default.createElement(_SvgInWarning.SvgInWarning, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: cn.content
  }, children), !closable ? null : /*#__PURE__*/_react.default.createElement(_iconButton.IconButton, {
    onClick: onClose,
    color: "gary"
  }, /*#__PURE__*/_react.default.createElement(_SvgBtClose.SvgBtClose, null)));
};

exports.PrimaryTip = PrimaryTip;
var view = ['usual', 'warning', 'info'];
var size = ['usual', 'small'];
PrimaryTip.modes = {
  view: view,
  size: size
};
PrimaryTip.propTypes = {
  /* component logic props */
  children: _propTypes.node.isRequired,
  closable: _propTypes.bool,
  onClose: _propTypes.func,

  /* styling modificators */
  view: (0, _propTypes.oneOf)(view),
  size: (0, _propTypes.oneOf)(size),

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
PrimaryTip.defaultProps = {
  closable: false,
  classes: {},
  onClose: function onClose() {},
  view: 'usual',
  size: 'usual'
};